import { fmtTL } from "../../lib/format";
import { cls } from "./personnelShared";
import { DEFAULT_WAGE_TYPES } from "./PersonnelWage";

// çoklu seçim rozetleri — boş seçim = tümü
export function ChipMulti({ label, options, value, onChange, testid, fmt = (v) => v }) {
  const all = value.length === 0;
  const toggle = (v) => onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  return (
    <div data-testid={testid}>
      <div className="flex items-center gap-2 text-[10px] uppercase tracking-wider text-slate-500 font-semibold mb-1">
        {label}<span className="text-slate-400 normal-case">({all ? "tümü" : `${value.length} seçili`})</span>
        {!all && <button type="button" onClick={() => onChange([])} className="underline text-slate-500 normal-case" data-testid={`${testid}-clear`}>temizle</button>}
      </div>
      <div className="flex flex-wrap gap-1 max-h-24 overflow-y-auto">
        {options.map((o) => (
          <button type="button" key={String(o.v)} onClick={() => toggle(o.v)} data-testid={`${testid}-${o.v}`}
            className={`px-2 py-0.5 rounded-full border text-[11px] transition-colors ${value.includes(o.v) ? "bg-orange-600 text-white border-orange-600" : "bg-white border-slate-300 hover:bg-slate-50"}`}>
            {fmt(o.v)} <span className="opacity-70">({o.n})</span>
          </button>
        ))}
        {options.length === 0 && <span className="text-[11px] text-slate-400">—</span>}
      </div>
    </div>
  );
}

// değer sayımı → [{v, n}] (sayısal değerler büyükten küçüğe, metinler alfabetik)
export const countOpts = (rows, pick, numeric = false) => {
  const m = new Map();
  rows.forEach((p) => { const v = pick(p); if (v === undefined || v === null || v === "") return; m.set(v, (m.get(v) || 0) + 1); });
  return [...m.entries()].map(([v, n]) => ({ v, n })).sort((a, b) => (numeric ? b.v - a.v : String(a.v).localeCompare(String(b.v), "tr")));
};

// Kapsam: proje → bölge / şube / görev / pozisyon → mevcut brüt / net (her biri tekli ya da çoklu)
export default function BulkRaiseFilters({ f, setF, projects, regions, locations, base, afterRegion, afterLoc, afterDuty, curOf }) {
  const set = (k) => (v) => setF({ ...f, [k]: v });
  const nameOf = (list, id) => list.find((x) => x.id === id)?.name || "—";
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Proje
          <select value={f.project} onChange={(e) => setF({ ...f, project: e.target.value, regions: [], locs: [], duties: [], positions: [], gross: [], net: [] })} className={`${cls} block !w-72`} data-testid="raise-project">
            <option value="">Proje seçin…</option>{projects.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
          </select>
        </label>
        <label className="text-[10px] uppercase tracking-wider text-slate-500 font-semibold">Ücret Türü
          <select value={f.type} onChange={(e) => setF({ ...f, type: e.target.value, gross: [], net: [] })} className={`${cls} block !w-36`} data-testid="raise-type">
            {DEFAULT_WAGE_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
        </label>
        <span className="text-[11px] text-slate-500 pb-1.5">{f.project ? `${base.length} aktif personel` : "Önce proje seçin"}</span>
      </div>
      {f.project && (
        <div className="grid md:grid-cols-2 gap-3">
          <ChipMulti label="Bölge" testid="raise-region" value={f.regions} onChange={set("regions")} options={countOpts(base, (p) => p.region_id)} fmt={(v) => nameOf(regions, v)} />
          <ChipMulti label="Şube / Departman" testid="raise-loc" value={f.locs} onChange={set("locs")} options={countOpts(afterRegion, (p) => p.location_id)} fmt={(v) => nameOf(locations, v)} />
          <ChipMulti label="Görevi" testid="raise-duty" value={f.duties} onChange={set("duties")} options={countOpts(afterLoc, (p) => p.duty || "GÖREV GİRİLMEMİŞ")} />
          <ChipMulti label="Pozisyon" testid="raise-position" value={f.positions} onChange={set("positions")} options={countOpts(afterLoc, (p) => p.position || "—")} />
          <ChipMulti label={`Mevcut ${f.type} Brüt`} testid="raise-gross" value={f.gross} onChange={set("gross")} options={countOpts(afterDuty, (p) => curOf(p).gross_salary || 0, true)} fmt={fmtTL} />
          <ChipMulti label={`Mevcut ${f.type} Net`} testid="raise-net" value={f.net} onChange={set("net")} options={countOpts(afterDuty, (p) => curOf(p).net_salary || 0, true)} fmt={fmtTL} />
        </div>
      )}
    </div>
  );
}
